<div class="box-mini col" [ngClass]="{nodata: !isDataAvailable}">
    <div class="box-mini__icon"><img src="/assets/img/sura-icon-circle-km.svg" alt="Sura Icon Pay" /></div>
    <div class="box-mini__title">
        <h4>Kilómetros recorridos mes anterior</h4>
    </div>
    <div class="box-mini__km" *ngIf="isDataAvailable">
        <h2 style="padding-left: 20px;">{{item.totalKms | number:'1.0':'es-CL' }}<sub>kms</sub></h2>
        <p>Período: <span class="cyan">{{ item.periodo }}</span></p>
    </div>
    <div *ngIf="isDataAvailable" class="box-mini__btn"><a class="button button-secondary button-small" (click)='logEventVerViajes()' [routerLink]="['/viajes']">VER VIAJES</a></div>
    <div *ngIf="!isDataAvailable" class="box-mini__desc-data"><img class="info-data" src="/assets/img/sura-icon-info-nodata.svg" alt="SURA ICON INFO NO DATA"/>
        <p>No tienes kilómetros registrados en el mes anterior.</p>
    </div>
</div>
